import React from "react";
import { useNavigate } from "react-router-dom";
import "./PrivacyPolicyPage.css";
import legalArticles from "../content/legalArticles.generated";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const article = legalArticles.privacy;

  return (
    <main className="landing-legal-page">
      <div className="landing-page-width">
        <article
          className="landing-legal-page__article"
          dangerouslySetInnerHTML={{ __html: article.articleHtml }}
        />
      </div>

      <div className="landing-cobalt-pagefoot">
        <div className="landing-page-width landing-page-width--ruled-top">
          <div className="landing-cobalt-pagefoot__inner">
            <span>© {new Date().getFullYear()} InvestX</span>
            <div className="landing-cobalt-pagefoot__links">
              <button type="button" onClick={() => navigate("/")}>
                Home
              </button>
              <button type="button" onClick={() => navigate("/privacy")}>
                Privacy
              </button>
              <button type="button" onClick={() => navigate("/support")}>
                Support
              </button>
              <button type="button" onClick={() => navigate("/terms")}>
                Terms
              </button>
              <button type="button" onClick={() => navigate("/delete-account")}>
                Delete account
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default PrivacyPolicyPage;
